import { EColor, ThemeColorType } from '@core/type';

import { themeDarkPalette } from './theme-dark-palette';
import { themeDefaultPalette } from './theme-default-palette';

export const themeColorList: ThemeColorType = {
  [EColor.MAIN]: themeDefaultPalette,
  [EColor.DARK]: themeDarkPalette,
};
